/* TODO: t() */
import React, { useRef, useEffect } from 'react';

type Props = {
  onResize: (width: number, height: number) => unknown;
};

function ResizeSensor(props: Props) {
  let ref = useRef<HTMLDivElement>(null);
  let { onResize } = props;
  useEffect(() => {
    let isCancelled = false;
    let contentWindow: Window | null = null;
    let resizeHandler = () => {
      if (contentWindow) {
        onResize(contentWindow.innerWidth, contentWindow.innerHeight);
      }
    };
    let frame = createFrame(() => {
      if (!isCancelled) {
        contentWindow = frame.contentWindow;
        contentWindow?.addEventListener('resize', resizeHandler);
        // Fire initial resize event as soon as we've loaded.
        resizeHandler();
      }
    });
    Object.assign(frame.style, styles.frame);
    ref.current && ref.current.appendChild(frame);
    return () => {
      isCancelled = true;
      contentWindow &&
        contentWindow.removeEventListener('resize', resizeHandler);
    };
  }, [onResize]);
  return (
    <div
      ref={ref}
      style={styles.root}
      aria-label="resize-sensor"
      aria-hidden={true}
    />
  );
}

function createFrame(callback: () => void): HTMLIFrameElement {
  let frame = document.createElement('iframe');
  let onLoad = () => {
    frame.removeEventListener('load', onLoad);
    callback();
  };
  frame.addEventListener('load', onLoad);
  frame.src = 'about:blank';
  return frame;
}

let styles: ObjectOf<React.CSSProperties> = {
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: -1,
  },
  frame: {
    display: 'block',
    opacity: '0',
    width: '100%',
    height: '100%',
    border: '0',
    margin: '0',
    padding: '0',
  },
};

export default ResizeSensor;
